import 'stylesheets/components/page.scss';
import 'stylesheets/components/button.scss';
import 'stylesheets/global.scss';

import React, { PropTypes }     from 'react';
import { bindActionCreators }   from 'redux';
import { connect }              from 'react-redux';

import PureRenderComponent                  from 'app/lib/PureRenderComponent';
import { isRequestingResource }             from 'modules/app/selectors';
import { getVisits }                        from 'modules/visits/selectors';
import * as actionCreators                  from 'modules/visits/actions';
import { VisitOverview }                    from '../components/VisitOverview';

export class VisitOverviewContainer extends PureRenderComponent {

    static propTypes = {
        actions: PropTypes.shape({
            getVisits: PropTypes.func
        })
    };

    componentDidMount() {
        this.props.actions.getVisits();
    }

    render() {
        return <VisitOverview {...this.props} />;
    }

}

function mapStateToProps(state) {
    return {
        visits: getVisits(state),
        isLoading: isRequestingResource(state, 'visits')
    };
}

function mapDispatchToProps(dispatch) {
    let actions = {};
    actions.getVisits = bindActionCreators(actionCreators.getVisits, dispatch).request;
    actions.deleteVisit = bindActionCreators(actionCreators.deleteVisit, dispatch).request;
    actions.getUnits = bindActionCreators(actionCreators.getUnits, dispatch).request;
    actions.getGoods = bindActionCreators(actionCreators.getGoods, dispatch).request;
    actions.getDocs = bindActionCreators(actionCreators.getDocs, dispatch).request;

    return {
        actions
    };
}

export default connect(mapStateToProps,mapDispatchToProps)(VisitOverviewContainer);
